import './App.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import Home from './pages/Home';
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import KycSuccess from './pages/Success';
import KycFailed from './pages/Fail';

function App() {
  return (
    <>
      <Router>
        <Routes>
          <Route
            path="/verify-aadhaar"
            element={<Home />}
          />
          <Route
            path="/success"
            element={<KycSuccess />}
          />
          <Route
            path="/failed"
            element={<KycFailed />}
          />
        </Routes>
      </Router>

    </>
  );
}

export default App;
